export enum Role {
  SuperAdmin=1,
  Admin=2,
  User=3,
  None=0
}
